// // src/Components/Pages/Skincare/SecondSection.jsx
// import React from 'react';

// const SecondSection = ({ items }) => {
//   if (!items?.length) return null;

//   return (
//     <>
//     <div className="py-0 sm:py-0 hidden sm:block">
//       <div className="bg-[#D9F1E7] px-6 sm:px-20 rounded-lg w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
//         {items.map((item, i) => (
//           <div
//             key={item.id}
//             className={`
//               p-4 sm:p-6
//               ${i < items.length - 1 ? 'border-r-2 border-[#676C8080]' : ''}
//               flex flex-col items-start bg-transparent
//             `}
//           >
//             {/* icon is now flush left */}
//             <img
//               src={item.imgurl}
//               alt={item.imgurl}
//               className="h-[70px] w-[55px] bg-transparent"
//             />

//             {/* left-aligned text */}
//             <h1 className="md:hidden mt-4 text-[#004171] font-bold text-left">
//               {item.description}
//             </h1>
//             <p className="hidden md:block mt-4 text-[10px] sm:text-base text-[#004171] font-bold text-left">
//               {item.description}
//             </p>
//           </div>
//         ))}
//       </div>
//     </div>


//       <div className="py-4 sm:py-8 block sm:hidden">
//       <div className="bg-[#D9F1E7] px-6 sm:px-20 rounded-lg w-full grid grid-cols-2 md:grid-cols-4 gap-4">
//         {items.map((item, i) => {
//           const isMobileLeft = i % 2 === 0;
//           const isMobileRight = i % 2 === 1;

//           return (
//             <div
//               key={item.id}
//               className={`
//                 p-4 sm:p-6 bg-transparent flex flex-col items-start
//                 ${isMobileLeft ? 'border-r-2 border-[#676C8080] md:border-r-0' : ''}
//                 md:border-r-2 md:border-[#676C8080]
//               `}
//             >
//               <img
//                 src={item.imgurl}
//                 alt={item.heading}
//                 className="h-[70px] w-[55px] bg-transparent"
//               />
//               <h1 className="md:hidden mt-4 text-[#004171] font-bold text-left">
//                 {item.description}
//               </h1>
//               <p className="hidden md:block mt-4 text-[10px] sm:text-base text-[#004171] font-bold text-left">
//                 {item.description}
//               </p>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//     </>
//   );
// };

// export default SecondSection;

// src/Components/Pages/Skincare/SecondSection.jsx
// src/Components/Pages/Skincare/SecondSection.jsx
import React from 'react';

const SecondSection = ({ items }) => {
  if (!items?.length) return null;

  return (
    <>
    <div className="py-0 sm:py-0 hidden sm:block">
      <div className="bg-[#D9F1E7] px-6 sm:px-12 xl:px-[max(48px,calc(50%_-_672px))] py-3 sm:py-4 w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-2">
        {items.map((item, i) => (
          <div
            key={item.id}
            className={`
              p-4 sm:p-6
              flex flex-col items-center bg-transparent
            `}
          >
            {/* icon is now flush left */}
            <img
              src={item.imgurl}
              alt={item.imgurl}
              className="h-[100px] w-[100px] bg-transparent"
            />

            {/* left-aligned text */}
            <h1 className="md:hidden mt-4 text-[#3A3A3A] text-base font-normal text-center">
              {item.description}
            </h1>
            <p className="hidden md:block mt-4 text-[#3A3A3A] font-normal  text-base  text-center">
              {item.description}
            </p>
          </div>
        ))}
      </div>
    </div>


      <div className="py-0 sm:py-0 block sm:hidden">
      <div className="bg-[#D9F1E7] px-6 sm:px-12 xl:px-[max(48px,calc(50%_-_672px))] py-3 sm:py-4 w-full grid grid-cols-2 md:grid-cols-4 gap-4">
        {items.map((item, i) => {
          const isMobileLeft = i % 2 === 0;
          const isMobileRight = i % 2 === 1;

          return (
            <div
              key={item.id}
              className={`
                p-4 sm:p-6 bg-transparent flex flex-col items-start
              `}
            >
              <img
                src={item.imgurl}
                alt={item.heading}
                className="h-[70px] w-[55px] bg-transparent"
              />
              <h1 className="md:hidden mt-4 text-[#004171] font-bold text-left">
                {item.description}
              </h1>
              <p className="hidden md:block mt-4 text-[10px] sm:text-base text-[#004171] font-bold text-left">
                {item.description}
              </p>
            </div>
          );
        })}
      </div>
    </div>
    </>
  );
};

export default SecondSection;